var render = function render(){var _vm=this,_c=_vm._self._c;return _c(_vm.tagType,_vm._g(_vm._b({tag:"component",class:[{
    'mm-button': true,
    'mm-button__circle': _vm.circle,
    'mm-button__ghost': _vm.ghost,
    [`mm-button__${_vm.type}`]: _vm.type,
    'mm-button--icon': _vm.isIconButton,
    'mm-button--block': _vm.block,
    'mm-button--loading': _vm.loading,
  }, _vm.themeClasses],attrs:{"type":_vm.nativeType,"disabled":_vm.disabled}},'component',_vm.attrProps,false),_vm.listeners),[(_vm.icon && _vm.iconType === 'left')?_c('ui-icon',{class:_vm.isIconButton ? '' : 'mm-button-icon__left',attrs:{"name":_vm.icon,"size":_vm.iconSize}}):_vm._e(),(_vm.loading)?_c('div',{staticClass:"mm-button-loading"},[_c('ui-loading',{attrs:{"stroke-width":4}})],1):_vm._e(),_vm._t("default"),(_vm.icon && _vm.iconType === 'right')?_c('ui-icon',{class:_vm.isIconButton ? '' : 'mm-button-icon__right',attrs:{"name":_vm.icon,"size":_vm.iconSize}}):_vm._e()],2)
}
var staticRenderFns = []

export { render, staticRenderFns }